<h2 mat-dialog-title>Upload PDF File</h2>
<div mat-dialog-content>
  <input type="file" (change)="onFileSelected($event)" accept=".pdf" />
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button color="primary" (click)="onUpload()">Submit</button>
</div>
